// extracted by mini-css-extract-plugin
module.exports = {"header":"_1qgWc","headerRightSide":"_3pFAb","moreButton":"_3xaTa"};